import { Alert, AlertTitle, Box } from "@mui/material";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { LoadingPage } from "components/pages";
import { useAuth } from "hooks/useAuth";

export function LoginCallbackScreen() {
  const { t } = useTranslation();
  const { loginError } = useAuth();

  if (loginError) {
    return (
      <Box sx={{ padding: 5 }}>
        <Alert severity="error">
          <AlertTitle>{t("login_error_title")}</AlertTitle>
          {t("login_error_message")}
          <br />
        </Alert>
        <br />
        <Link to={"/auth/login"}>{t("go_to_login_page")}</Link>
      </Box>
    );
  }
  return <LoadingPage />;
}
